import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Composer from 'flarum/forum/components/Composer';

/**
 * Fixes iOS WebKit caret/cursor offset bug in Firefox (FxiOS), Chrome (CriOS) and other iOS browsers.
 *
 * Background:
 * Flarum core fixes an iOS Safari bug with `position: fixed` in Composer by adding `.mobile-safari`
 * and switching the composer to `position: absolute; top: topOfViewport`.
 * However, Flarum's `isSafariMobile()` explicitly excludes `FxiOS` (Firefox) and `CriOS` (Chrome).
 * Since Apple mandates WebKit for ALL browsers on iOS, Firefox and Chrome suffer from the exact
 * same WebKit viewport desync: the rendered text and the native caret/tap hit-testing desync by ~2 lines.
 *
 * This helper ensures that all iOS browsers receive the `.mobile-safari` compatibility class
 * and that Composer positions properly on phone screens.
 */
export default function fixIOSWebKitComposer() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  if (!isIOS) return;
  const ensureClass = () => {
    const appEl = document.getElementById('app') || document.querySelector('.App');
    if (appEl && !appEl.classList.contains('mobile-safari')) {
      appEl.classList.add('mobile-safari');
    }
  };

  // Run immediately and on DOM ready
  ensureClass();
  if (typeof $ !== 'undefined') {
    $(ensureClass);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureClass);
  }

  // Also hook into Composer.prototype.show to ensure Composer stays fixed at the top on phone screens
  extend(Composer.prototype, 'show', function () {
    if (app.screen() === 'phone') {
      ensureClass();
      this.$().css('top', '0');
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  });
}